exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#event-report-table .expandable {\n  cursor: pointer;\n}\n#event-report-table tr.registration {\n  background: #fafafa;\n}\n.event-report-toolbar .v-input__slot {\n  margin-bottom: 2px !important;\n}\n", ""]);

// exports
